import React from "react";
import { withRouter } from "react-router";
import { withUser } from "@unifiedpatents/sso";
import { ChartPreparationProvider } from "./context/chart-preparation-context";
import { PriorArtMappingProvider } from "./context/prior-art-mapping-context";

const styles = {
  body: {
    width: "100%",
    padding: 30
  },
};

const ClaimChartContextWrapper = ({ children, location, router, user }) => {
  const { chartId } = router.params;
  const pathSegment = location.pathname.split('/')[2];

  const { status: { isLoggedIn }, metadata: { authorization }} = user;
  const hasAccess = authorization.roles.includes("member-auto-claim-chart") || 
                    authorization.roles.includes("member-auto-claim-chart-trial") ||
                    isLoggedIn;

  return (
    <>
      {hasAccess ? (
        <div key={`${pathSegment}-${chartId}`}>
          <ChartPreparationProvider>
            <PriorArtMappingProvider>
              {children}
            </PriorArtMappingProvider>
          </ChartPreparationProvider>
        </div>
      ) : (
        <div style={styles.body}>
          <p>
            Please log in to get access to this functionality.
          </p>
        </div>
      )}
    </>
  );
};

export default withRouter(withUser(ClaimChartContextWrapper));
